import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'td',
  standalone: false,
})
export class TableCellOverflowTitleDirective {
  constructor(private readonly element: ElementRef<HTMLTableCellElement>) {}

  @HostListener('mouseenter')
  exposeOverflowingText(): void {
    const cell = this.element.nativeElement;
    if (cell.closest('.card-table, .table-list') === null) return;

    const text = cell.innerText.replace(/\s+/g, ' ').trim();
    if (text && cell.scrollWidth > cell.clientWidth) {
      cell.title = text;
    } else if (!cell.hasAttribute('data-keep-title')) {
      cell.removeAttribute('title');
    }
  }
}
